import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadGroupFinanceByGroupId: IGroupFinanceLoadByGroupIdActionCreator = (groupId) => {
        return {
            type: ACTION_GROUPFINANCE_LOAD_BY_GROUP_ID,
            groupId
        }
    },
    LoadGroupFinanceById: IGroupFinanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_GROUPFINANCE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IGroupFinanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IGroupFinanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveGroupFinance: IGroupFinanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_GROUPFINANCE_SAVE,
            formData
        }
    },
    SaveSuccess: IGroupFinanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IGroupFinanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateGroupFinance: IGroupFinanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_GROUPFINANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IGroupFinanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IGroupFinanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateGroupFinance: IGroupFinanceCreateActionCreator = (groupId) => {

        return {
            type: ACTION_GROUPFINANCE_CREATE,
            groupId
        }
    },
    CreateSuccess: IGroupFinanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_GROUPFINANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IGroupFinanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncGroupFinance: IGroupFinanceSyncActionCreator = (groupId) => {

        return {
            type: ACTION_GROUPFINANCE_SYNC,
            groupId
        }
    },
    SyncSuccess: IGroupFinanceSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: IGroupFinanceSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPFINANCE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: IGroupFinanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_GROUPFINANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: IGroupFinanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_GROUPFINANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_GROUPFINANCE_LOAD_BY_GROUP_ID = "ACTION_GROUPFINANCE_LOAD_BY_GROUP_ID",
    ACTION_GROUPFINANCE_LOAD_BY_ID = "ACTION_GROUPFINANCE_LOAD_BY_ID",
    ACTION_GROUPFINANCE_LOAD_SUCCESS = "ACTION_GROUPFINANCE_LOAD_SUCCESS",
    ACTION_GROUPFINANCE_LOAD_FAILURE = "ACTION_GROUPFINANCE_LOAD_FAILURE",

    ACTION_GROUPFINANCE_SAVE = "ACTION_GROUPFINANCE_SAVE",
    ACTION_GROUPFINANCE_SAVE_SUCCESS = "ACTION_GROUPFINANCE_SAVE_SUCCESS",
    ACTION_GROUPFINANCE_SAVE_FAILURE = "ACTION_GROUPFINANCE_SAVE_FAILURE",

    ACTION_GROUPFINANCE_VALIDATE = "ACTION_GROUPFINANCE_VALIDATE",
    ACTION_GROUPFINANCE_VALIDATE_SUCCESS = "ACTION_GROUPFINANCE_VALIDATE_SUCCESS",
    ACTION_GROUPFINANCE_VALIDATE_FAILURE = "ACTION_GROUPFINANCE_VALIDATE_FAILURE",

    ACTION_GROUPFINANCE_CREATE = "ACTION_GROUPFINANCE_CREATE",
    ACTION_GROUPFINANCE_CREATE_SUCCESS = "ACTION_GROUPFINANCE_CREATE_SUCCESS",
    ACTION_GROUPFINANCE_CREATE_FAILURE = "ACTION_GROUPFINANCE_CREATE_FAILURE",

    ACTION_GROUPFINANCE_SYNC = "ACTION_GROUPFINANCE_SYNC",
    ACTION_GROUPFINANCE_SYNC_SUCCESS = "ACTION_GROUPFINANCE_SYNC_SUCCESS",
    ACTION_GROUPFINANCE_SYNC_FAILURE = "ACTION_GROUPFINANCE_SYNC_FAILURE",

    ACTION_GROUPFINANCE_CLEAR = "ACTION_GROUPFINANCE_CLEAR",

    ACTION_GROUPFINANCE_FILTER = "ACTION_GROUPFINANCE_FILTER";

export interface IGroupFinanceLoadByGroupIdAction {
    type: "ACTION_GROUPFINANCE_LOAD_BY_GROUP_ID";
    groupId: number;
}

export interface IGroupFinanceLoadByGroupIdActionCreator {
    (groupId: number): IGroupFinanceLoadByGroupIdAction;
}

export interface IGroupFinanceLoadSuccessAction {
    type: "ACTION_GROUPFINANCE_LOAD_SUCCESS";
    formData: Dtos.GroupFinance | Dtos.GroupFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupFinanceLoadSuccessActionCreator {
    (
        formData: Dtos.GroupFinance | Dtos.GroupFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupFinanceLoadSuccessAction;
}

export interface IGroupFinanceLoadFailureAction {
    type: "ACTION_GROUPFINANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupFinanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupFinanceLoadFailureAction;
}

export interface IGroupFinanceLoadByIdAction {
    type: "ACTION_GROUPFINANCE_LOAD_BY_ID";
    id: number;
}

export interface IGroupFinanceLoadByIdActionCreator {
    (id: number): IGroupFinanceLoadByIdAction;
}

export interface IGroupFinanceSaveAction {
    type: "ACTION_GROUPFINANCE_SAVE";
    formData: Dtos.GroupFinance;

}

export interface IGroupFinanceSaveActionCreator {
    (
        formData: Dtos.GroupFinance
    ): IGroupFinanceSaveAction;
}

export interface IGroupFinanceSaveSuccessAction {
    type: "ACTION_GROUPFINANCE_SAVE_SUCCESS";
    formData: Dtos.GroupFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupFinanceSaveSuccessActionCreator {
    (
        formData: Dtos.GroupFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupFinanceSaveSuccessAction;
}

export interface IGroupFinanceSaveFailureAction {
    type: "ACTION_GROUPFINANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupFinanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupFinanceSaveFailureAction;
}

export interface IGroupFinanceValidateAction {
    type: "ACTION_GROUPFINANCE_VALIDATE";
    formData: Dtos.GroupFinance;

}

export interface IGroupFinanceValidateActionCreator {
    (
        formData: Dtos.GroupFinance
    ): IGroupFinanceValidateAction;
}

export interface IGroupFinanceValidateSuccessAction {
    type: "ACTION_GROUPFINANCE_VALIDATE_SUCCESS";
    formData: Dtos.GroupFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupFinanceValidateSuccessActionCreator {
    (
        formData: Dtos.GroupFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IGroupFinanceValidateSuccessAction;
}

export interface IGroupFinanceValidateFailureAction {
    type: "ACTION_GROUPFINANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupFinanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupFinanceValidateFailureAction;
}

export interface IGroupFinanceCreateAction {
    type: "ACTION_GROUPFINANCE_CREATE",
    groupId: number
}

export interface IGroupFinanceCreateActionCreator {
    (groupId: number): IGroupFinanceCreateAction
}

export interface IGroupFinanceCreateSuccessAction {
    type: "ACTION_GROUPFINANCE_CREATE_SUCCESS";
    formData: Dtos.GroupFinance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IGroupFinanceCreateSuccessActionCreator {
    (
        formData: Dtos.GroupFinance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IGroupFinanceCreateSuccessAction;
}

export interface IGroupFinanceCreateFailureAction {
    type: "ACTION_GROUPFINANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupFinanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupFinanceCreateFailureAction;
}

export interface IGroupFinanceClearAction {
    type: "ACTION_GROUPFINANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface IGroupFinanceClearActionCreator {
    (propertiesToClear?: string[]): IGroupFinanceClearAction;
}

export interface IGroupFinanceFilterActionCreator {
    (formFilter: IFormFilter): IGroupFinanceFilterAction;
}

export interface IGroupFinanceFilterAction {
    type: "ACTION_GROUPFINANCE_FILTER";
    formFilter: IFormFilter;
}

export interface IGroupFinanceSyncAction {
    type: "ACTION_GROUPFINANCE_SYNC",
    groupId: number
}

export interface IGroupFinanceSyncActionCreator {
    (groupId: number): IGroupFinanceSyncAction
}

export interface IGroupFinanceSyncSuccessAction {
    type: "ACTION_GROUPFINANCE_SYNC_SUCCESS";
    formData: Dtos.GroupFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupFinanceSyncSuccessActionCreator {
    (
        formData: Dtos.GroupFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupFinanceSyncSuccessAction;
}

export interface IGroupFinanceSyncFailureAction {
    type: "ACTION_GROUPFINANCE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IGroupFinanceSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupFinanceSyncFailureAction;
}

export type GroupFinanceAction =
    IGroupFinanceLoadByGroupIdAction |
    IGroupFinanceLoadByIdAction |
    IGroupFinanceLoadFailureAction |
    IGroupFinanceLoadSuccessAction |
    IGroupFinanceSaveAction |
    IGroupFinanceSaveSuccessAction |
    IGroupFinanceSaveFailureAction |
    IGroupFinanceValidateAction |
    IGroupFinanceValidateSuccessAction |
    IGroupFinanceValidateFailureAction |
    IGroupFinanceCreateAction |
    IGroupFinanceCreateSuccessAction |
    IGroupFinanceCreateFailureAction |
    IGroupFinanceSyncAction |
    IGroupFinanceSyncSuccessAction |
    IGroupFinanceSyncFailureAction |
    IGroupFinanceClearAction | 
    IGroupFinanceFilterAction;
